import { plural } from '@cian/utils';

export function getBedsLabel(value: number): string {
  return `${value} ${plural(value, ['гость', 'гостя', 'гостей'])}`;
}
